module.exports = __webpack_public_path__ + "static/media/tw_im.109dd9c4.svg";